import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { renameMe } from '../../entities/user';
import type { TUser } from '../../entities/session';

export const useAccountProfile = (user: TUser) => {
  const client = useQueryClient();
  const [draft, setDraft] = useState<string | null>(null);
  const name = draft ?? user.name;
  const nameOk = name.trim().length > 0 && name.trim().length <= 120;
  const dirty = name.trim() !== user.name;

  const save = useMutation({
    mutationFn: () => renameMe(name.trim()),
    onSuccess: async () => {
      setDraft(null);
      await client.invalidateQueries({ queryKey: ['session'] });
    },
  });

  return { name, change: setDraft, nameOk, dirty, save };
};

export type TAccountProfile = ReturnType<typeof useAccountProfile>;
